import React, { useEffect } from 'react';
import NotFoundImage from '../../images/NotFoundImage.png';
import NotFoundClipboard from '../../images/NotFoundClipboard.svg';
import { useNavigate } from 'react-router-dom';
import { isMenuCollapsed, userTier } from '../../apollo/cache';
import { useReactiveVar } from '@apollo/client';
import { Page } from '../layout';
import { isUserIndustryOnlyTier } from '../shared/services/checkUserTierService';
import IndustryOnlyNotFoundButtons from './IndustryOnlyNotFoundButtons';
import NotFoundButtons from './NotFoundButtons';
import { Breadcrumb } from '../shared/components/breadcrumb/Breadcrumb';

const NotFoundPage = () => {
  const tier = useReactiveVar(userTier);

  const pageTitle = 'Page Not Found';
  const breadcrumbPathItems = [{ name: pageTitle, url: '' }];

  const navigate = useNavigate();

  useEffect(() => {
    isMenuCollapsed(false);
  }, []);

  const handleBtnClick = pageLink => {
    navigate(pageLink);
  };

  return (
    <Page title={pageTitle}>
      <Breadcrumb pathItems={breadcrumbPathItems} />

      <div className='not-found-page'>
        <div className='content'>
          <img className='not-found-image' src={NotFoundImage} />
          <img className='clipboard' src={NotFoundClipboard} />
          <div className='button-group'>
            {isUserIndustryOnlyTier(tier) ? (
              <IndustryOnlyNotFoundButtons handleBtnClick={handleBtnClick} />
            ) : (
              <NotFoundButtons handleBtnClick={handleBtnClick} />
            )}
          </div>
        </div>
      </div>
    </Page>
  );
};

export default NotFoundPage;
